import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    // Skip scroll-to-top when only the language segment changes (/ar <-> /en)
    const state = location.state;
    if (state && state.languageSwitch) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}
